import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';

import Avatar from 'components/Avatar';
import Table from 'components/Table';
import Button from 'components/Button';
import Loading from 'components/Loading';
import {withFilters, FILTERS} from 'components/withFilters';

import {MemberStatus, SearchInput} from 'containers/MyTeams/components/shared';
import {fetchStaffMembers} from 'ducks/teams';

import './styles.css';

const initialFilters = {
  search: ''
};

const TeamNamesRow = ({teams}) => (
  <div className="teamNamesRow">
    {teams.length === 0 && (
      <div style={{textAlign: 'center'}}>This member has no teams</div>
    )}
    {teams.length > 0 && (
      <div className="teams">{teams.map(t => t.name).join(', ')}</div>
    )}
    <div className="restTeamsCount">{teams.length}</div>
  </div>
);

class AllStaffMembersTable extends React.Component<any> {
  onSearchChange = event => {
    const {target: {value}} = event;

    this.props.setFilter('search', value);
    this.fetchStaffMembers();
  };

  fetchStaffMembers = _.debounce(() => this.props.fetchStaffMembers(), 200);

  render() {
    const {
      staffMembers,
      teams,
      openInviteNewStaffMemberModal,
      openStaffMemberDetailModal,
      isLoading
    } = this.props;

    return (
      <div className="AllStaffMembersTable">
        <div className="header">
          <div className="heading">All staff members</div>
          <SearchInput
            placeholder="Search for staff members"
            onSearchChange={this.onSearchChange}
          />
        </div>
        <div className="tableContainer">
          {isLoading && <Loading />}
          {!isLoading && (
            <React.Fragment>
              <div className="tableHeader">
                <Table>
                  <Table.Header>
                    <Table.HeaderItem className="name" heading="name" />
                    <Table.HeaderItem className="teams" heading="teams" />
                    <Table.HeaderItem className="email" heading="email" />
                    <Table.HeaderItem
                      className="status"
                      heading="colab status"
                    />
                  </Table.Header>
                </Table>
              </div>
              <div className="tableBody">
                <Table>
                  <Table.Body>
                    {staffMembers.length > 0 &&
                      staffMembers.map(member => (
                        <Table.Row
                          key={member.id}
                          onClick={() =>
                            openStaffMemberDetailModal({memberId: member.id})
                          }>
                          <Table.Cell className="name">
                            <div className="memberInfoWrapper">
                              <Avatar
                                url={
                                  member.internalAvatarCropped ||
                                  member.avatarCropped
                                }
                                initials={member.initials}
                              />
                              <div className="text">
                                <div className="name">{member.name}</div>
                                <div className="jobTitle">
                                  {member.jobTitle}
                                </div>
                              </div>
                            </div>
                          </Table.Cell>
                          <Table.Cell className="teams">
                            <TeamNamesRow teams={member.teams} />
                          </Table.Cell>
                          <Table.Cell className="email">
                            {member.email}
                          </Table.Cell>
                          <Table.Cell className="status">
                            <MemberStatus status={member.status} />
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    {staffMembers.length === 0 && (
                      <Table.Row>
                        <Table.Cell colSpan="5">
                          <div style={{textAlign: 'center'}}>
                            Staff Members list is empty
                          </div>
                        </Table.Cell>
                      </Table.Row>
                    )}
                  </Table.Body>
                </Table>
              </div>
            </React.Fragment>
          )}
        </div>
        {teams.length > 0 && (
          <div className="footer">
            <Button white onClick={openInviteNewStaffMemberModal}>
              Invite new
            </Button>
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = {
  fetchStaffMembers
};

export default connect(null, mapDispatchToProps)(
  withFilters(AllStaffMembersTable, FILTERS.MY_TEAMS_MEMBERS, {
    initialFilters
  })
);
